module.exports = __webpack_public_path__ + "static/media/login@2x.a6951505.png";